import * as axios from 'axios';
import { API } from './config';
import { logger } from './logger';

const createWhatsappBot = async function (payload) {
  let endpoint = '/api/chatbot/app/create';
  try {
    let config = getAuthHeaders();
    console.log("Auth Headers", config);
    console.log('payload', payload);
    const response = await axios.post(`${API}${endpoint}`, payload, config);
    logger.info('Response from createWhatsappBot', response.data);
    return response.data;
  } catch (error) {
    console.log('Error createWhatsappBot>>', error);
    const resp = {};
    resp.error = error;
    return resp;
  }
};

const deleteWhatsappBot = async function (appId) {
  let endpoint = `/api/chatbot/app/${appId}`;
  try {
    let config = getAuthHeaders();
    const response = await axios.delete(`${API}${endpoint}`, config);
    logger.info('Response from deleteWhatsappBot', response.data);
    return response.data;
  } catch (error) {
    console.log('Error deleteWhatsappBot>>', error);
    const resp = {};
    resp.error = error;
    return resp;
  }
};

const getWhatsappBotById = async function (appId) {
  let endpoint = `/api/chatbot/app/${appId}`;
  try {
    let config = getAuthHeaders();
    const response = await axios.get(`${API}${endpoint}`, config);
    logger.info('Response from getWhatsappBotById', response.data);
    return response.data;
  } catch (error) {
    console.log('Error getWhatsappBotById>>', error);
    const resp = {};
    resp.error = error;
    return resp;
  }
};

const updateWhatsappBot = async function (payload) {
  let endpoint = '/chatbot/app/update';
  try {
    let config = getAuthHeaders();
    const response = await axios.post(`${API}${endpoint}`, payload, config);
    logger.info('Response from updateWhatsappBot', response.data);
    return response.data;
  } catch (error) {
    console.log('Error updateWhatsappBot>>', error);
    const resp = {};
    resp.error = error;
    return resp;
  }
};

const getAllWhatsappBots = async function () {
  let endpoint = '/api/chatbot/apps';
  try {
    let config = getAuthHeaders();
    const response = await axios.get(`${API}${endpoint}`, config);
    logger.info('Response from getAllWhatsappBots', response.data);
    return response.data;
  } catch (error) {
    console.log('Error getAllWhatsappBots>>', error);
    const resp = {};
    resp.error = error;
    return resp;
  }
};

const changeBotStatus = async function (appId, status) {
  let endpoint = `/api/chatbot/app/${appId}/status`;
  try {
    let config = getAuthHeaders();
    const response = await axios.post(`${API}${endpoint}`, { status }, config);
    logger.info('Response from changeBotStatus', response.data);
    return response.data;
  } catch (error) {
    console.log('Error changeBotStatus>>', error);
    const resp = {};
    resp.error = error;
    return resp;
  }
};

const linkWhatsAppNumber = async function (payload) {
  let endpoint = '/api/chatbot/whatsapp/link';
  try {
    let config = getAuthHeaders();
    const response = await axios.post(`${API}${endpoint}`, payload, config);
    logger.info('Response from linkWhatsAppNumber', response.data);
    return response.data;
  } catch (error) {
    console.log('Error linkWhatsAppNumber>>', error);
    const resp = {};
    resp.error = error;
    return resp;
  }
};

const unlinkWhatsAppNumber = async function (linkId) {
  let endpoint = `/api/chatbot/whatsapp/unlink/${linkId}`;
  try {
    let config = getAuthHeaders();
    const response = await axios.get(`${API}${endpoint}`, {}, config);
    logger.info('Response from unlinkWhatsAppNumber', response.data);
    return response.data;
  } catch (error) {
    console.log('Error unlinkWhatsAppNumber>>', error);
    const resp = {};
    resp.error = error;
    return resp;
  }
};

const listLinkedWhatsAppNumbers = async function (chatBotAppId) {
  let endpoint = `/api/chatbot/whatsapp/list-numbers/${chatBotAppId}`;
  try {
    let config = getAuthHeaders();
    const response = await axios.get(`${API}${endpoint}`, config);
    logger.info('Response from listLinkedWhatsAppNumbers', response.data);
    return response.data;
  } catch (error) {
    console.log('Error listLinkedWhatsAppNumbers>>', error);
    const resp = {};
    resp.error = error;
    return resp;
  }
};

const checkLinkStatus = async function (linkId) {
  let endpoint = `/api/chatbot/whatsapp/link-status/${linkId}`;
  try {
    let config = getAuthHeaders();
    const response = await axios.get(`${API}${endpoint}`, config);
    logger.info('Response from checkLinkStatus', response.data);
    return response.data;
  } catch (error) {
    console.log('Error checkLinkStatus>>', error);
    const resp = {};
    resp.error = error;
    return resp;
  }
};

function getAuthHeaders() {
    let jwtToken = localStorage.getItem('token');
    let config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': jwtToken
      }
    };
    console.log('AuthHeader', config);
    return config;
}

export default {
  createWhatsappBot,
  deleteWhatsappBot,
  getWhatsappBotById,
  updateWhatsappBot,
  getAllWhatsappBots,
  changeBotStatus,
  linkWhatsAppNumber,
  unlinkWhatsAppNumber,
  listLinkedWhatsAppNumbers,
  checkLinkStatus
}; 